import { createContext, Dispatch, SetStateAction } from "react";
import { FilterBody } from "../../../../../hooks/filter/typing";
import { InputModel } from "../../../../../utils/types";
import { Item } from "../../../../../utils/types/generals";


export interface UserGroupContextType {

  fitlerMain: FilterBody;
  filterMainData: {
    items: {
      [x: string]: Item[];
    };
    input: {
      [x: string]: InputModel;
    };
    getData: () => Promise<void>;
  };
  selectedIds: number[];
  setSelectedIds: Dispatch<SetStateAction<number[]>>;
  notGroupSelected: number[];
  setNotGroupSelected: Dispatch<SetStateAction<number[]>>;
  isChecked: boolean;
  setIsChecked: Dispatch<SetStateAction<boolean>>;
  uuid: string;
  setUuid: Dispatch<SetStateAction<string>>;
}

export const UserGroupContext = createContext<UserGroupContextType>(
  {} as UserGroupContextType
);